var map = {
	"./espm.svg": "43dd",
	"./kantar_ibope.svg": "30c1",
	"./kantar_ibope_color.svg": "431b",
	"./logun.svg": "d0b3",
	"./logun_color.svg": "bd9b",
	"./tunad.svg": "80e3",
	"./tunad_color.svg": "ac40"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dcfe";